var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "25px",
        height: "25px",
        viewBox: "0 0 25 25",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "g",
        {
          attrs: {
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
          },
        },
        [
          _c("polygon", { attrs: { points: "0 0 25 0 25 25 0 25" } }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              fill: _vm.color,
              x: "2",
              y: "6",
              width: "20",
              height: "2",
              rx: "0.300000012",
            },
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              fill: _vm.color,
              x: "2",
              y: "11.5",
              width: "20",
              height: "2",
              rx: "0.300000012",
            },
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              fill: _vm.color,
              x: "2",
              y: "17",
              width: "20",
              height: "2",
              rx: "0.300000012",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }